<template>
  <div>
    <!-- Mobile Top Navigation Header -->
    <header class="d-md-none bg-body-tertiary border-bottom p-3 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <font-awesome-icon icon="fa-solid fa-user-shield" class="fs-4 text-warning me-2" />
        <span class="fs-5 fw-bold text-warning text-uppercase">Panel Admina</span>
      </div>
      <button
          class="btn btn-outline-warning btn-sm"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#adminSidebarOffcanvas"
          aria-controls="adminSidebarOffcanvas"
      >
        <font-awesome-icon icon="fa-solid fa-bars" class="me-1" /> Menu
      </button>
    </header>

    <!-- Desktop Sticky Sidebar -->
    <aside class="admin-sidebar bg-body-tertiary border-end p-3 d-none d-md-flex flex-column sticky-top">
      <div class="d-flex align-items-center mb-4 px-2">
        <font-awesome-icon icon="fa-solid fa-user-shield" class="fs-4 text-warning me-2" />
        <span class="fs-5 fw-bold text-warning text-uppercase">Panel Admina</span>
      </div>

      <ul class="nav nav-pills flex-column mb-auto gap-1">
        <li class="nav-item" v-for="tab in navTabs" :key="tab.id">
          <router-link
              :to="tab.path"
              class="nav-link w-100 text-start d-flex align-items-center"
              :class="{ active: $route.path === tab.path || ($route.path === '/admin' && tab.id === 'overview') }"
          >
            <font-awesome-icon :icon="tab.icon" class="me-2" />
            {{ tab.label }}
          </router-link>
        </li>
      </ul>

      <router-link
          to="/"
          class="nav-link w-100 text-start d-flex align-items-center"
      >
        <font-awesome-icon icon="fa-solid fa-house" class="me-2" />
        Wróc do strony
      </router-link>
      <hr class="my-3 opacity-25" />
      <div class="px-2 small text-muted">
        Zalogowany jako: <strong class="text-body-emphasis">{{ userEmail || 'Admin' }}</strong>
      </div>
    </aside>

    <!-- Mobile Offcanvas Sidebar Container -->
    <div
        class="offcanvas offcanvas-start bg-body-tertiary d-md-none"
        tabindex="-1"
        id="adminSidebarOffcanvas"
        aria-labelledby="adminSidebarOffcanvasLabel"
    >
      <div class="offcanvas-header border-bottom">
        <h5 class="offcanvas-title text-warning fw-bold d-flex align-items-center" id="adminSidebarOffcanvasLabel">
          <font-awesome-icon icon="fa-solid fa-user-shield" class="me-2" /> Panel Admina
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body d-flex flex-column">
        <ul class="nav nav-pills flex-column mb-auto gap-1">
          <li class="nav-item" v-for="tab in navTabs" :key="tab.id">
            <router-link
                :to="tab.path"
                class="nav-link w-100 text-start d-flex align-items-center"
                :class="{ active: $route.path === tab.path || ($route.path === '/admin' && tab.id === 'overview') }"
                data-bs-dismiss="offcanvas"
            >
              <font-awesome-icon :icon="tab.icon" class="me-2" />
              {{ tab.label }}
            </router-link>
          </li>
        </ul>

        <hr class="my-3 opacity-25" />

        <div class="px-2 small text-muted">
          Zalogowany jako: <strong class="text-body-emphasis">{{ userEmail || 'Admin' }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminMenu',
  props: {
    userEmail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      navTabs: [
        { id: 'overview', label: 'Przegląd', icon: 'fa-solid fa-chart-line', path: '/admin/overview' },
        { id: 'reservations', label: 'Rezerwacje', icon: 'fa-solid fa-calendar-check', path: '/admin/reservations' },
        { id: 'spaces', label: 'Stanowiska', icon: 'fa-solid fa-bullseye', path: '/admin/spaces' },
        { id: 'events', label: 'Wydarzenia', icon: 'fa-solid fa-bullhorn', path: '/admin/events' },
        { id: 'users', label: 'Użytkownicy', icon: 'fa-solid fa-users', path: '/admin/users' },
        { id: 'prices', label: 'Cennik', icon: 'fa-solid fa-tags', path: '/admin/prices' }
      ]
    }
  }
}
</script>

<style scoped>
.admin-sidebar {
  width: 260px;
  min-width: 260px;
  height: 100vh;
  overflow-y: auto;
  top: 0;
}

.admin-sidebar .nav-link,
.offcanvas-body .nav-link {
  color: var(--bs-body-color);
  font-weight: 500;
  border-radius: 0.5rem;
  padding: 0.65rem 1rem;
  transition: all 0.2s ease;
  text-decoration: none;
}

.admin-sidebar .nav-link:hover,
.offcanvas-body .nav-link:hover {
  background-color: var(--bs-secondary-bg);
  color: #f0c040;
}

.admin-sidebar .nav-link.active,
.offcanvas-body .nav-link.active {
  background-color: #f0c040;
  color: #000;
  font-weight: 700;
}
</style>